import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function StundenpensumWoche() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <>
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.label',
        )}
        item={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.options.woche',
        )}
      />
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.wochenstunden.label',
        )}
        item={
          data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.wochenstunden +
          ' ' +
          t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.wochenstunden.zusammenfassungSuffix',
          )
        }
      />
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenWoche.label',
        )}
        item={
          <span>
            {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger
              .unbezahlteUeberstundenWoche ?? '00:00'}
            {` ${t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenWoche.zusammenfassungSuffix',
            )}`}
          </span>
        }
      />
    </>
  );
}
